import { Tag } from '@noorden-insurtech/alba-design-system';
import type { ReactNode } from 'react';

/** Tons já usados nas telas do Portal — status, modos e contagens. */
export type BadgeTone =
  | 'success'
  | 'warning'
  | 'error'
  | 'gray'
  | 'blue'
  | 'purple'
  | 'yellow'
  | 'lightGreen';

export type BadgeProps = {
  tone?: BadgeTone;
  variant?: 'outline' | 'solid';
  children: ReactNode;
  className?: string;
};

/**
 * Etiqueta curta de status. Envolve o `Tag` do design system, que está saindo:
 * features importam daqui, nunca do pacote.
 */
export function Badge({
  tone = 'gray',
  variant = 'outline',
  children,
  className,
}: BadgeProps) {
  return (
    <Tag.Root
      variant={variant}
      colorScheme={tone}
      size='sm'
      className={className}
    >
      <Tag.Label>{children}</Tag.Label>
    </Tag.Root>
  );
}
